import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { useGoogleAdsDetection } from '../../utils/useGoogleAdsDetection';
import './hero.scss';

export default function Hero() {
  const { t } = useTranslation();
  const isFromGoogleAds = useGoogleAdsDetection();

  const handleGoogleMaps = () => {
    window.open('https://www.google.com/maps/dir//Av.+%C3%81lvares+Cabral,+894+-+Lourdes,+Belo+Horizonte+-+MG', '_blank', 'noopener,noreferrer');
  };

  return (
    <section className="hero" id="inicio">
      <div className="hero-background">
        <img 
          src="https://readdy.ai/api/search-image?query=Modern%20bright%20laundry%20room%20interior%20with%20white%20washing%20machines%20in%20a%20row%2C%20clean%20minimalist%20design%2C%20soft%20natural%20lighting%2C%20professional%20commercial%20space%20with%20plants%20and%20wooden%20accents%2C%20welcoming%20atmosphere%2C%20high%20quality%20photography&width=1920&height=1080&seq=hero-eco-lavanderia-001&orientation=landscape" 
          alt="Lavanderia self-service em BH"
          loading="eager"
          fetchPriority="high"
        />
        <div className="hero-overlay"></div>
      </div>
      
      <div className="container">
        <div className="hero-content">
          {/* H1 único e otimizado para Google Ads */}
          <h1 className="hero-title">
            Lavanderia Self Service em Lourdes – Lave ou Seque por R$16,99
          </h1>
          
          <motion.p 
            className="hero-subtitle"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            Aberto todos os dias das 6h às 23h em Lourdes – Belo Horizonte
          </motion.p>
          
          <motion.div 
            className="hero-cta"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
          >
            <button onClick={handleGoogleMaps} className="btn-primary btn-maps">
              <i className="ri-map-pin-line"></i>
              {isFromGoogleAds ? 'Abrir Rota no Google Maps' : t('hero.location')}
            </button>
          </motion.div>

          <motion.div 
            className="hero-features"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.6 }}
          >
            <div className="feature-item">
              <i className="ri-price-tag-3-line"></i>
              <span>Preço único e sem surpresas</span>
            </div>
            <div className="feature-item">
              <i className="ri-shield-check-line"></i>
              <span>Ambiente moderno e seguro</span>
            </div>
            <div className="feature-item">
              <i className="ri-customer-service-2-line"></i>
              <span>Atendimento Humanizado</span>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}